/* VENRO storefront behaviour */
(function () {
  'use strict';
  var CFG = window.venro || {};
  var routes = CFG.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function fmtMoney(cents) {
    var fmt = CFG.moneyFormat || '{{amount}}';
    function num(v, dec, thousand, decimal) {
      if (isNaN(v) || v === null) v = 0;
      v = (v / 100).toFixed(dec);
      var parts = v.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      return dec ? head + decimal + parts[1] : head;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('VenroToast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------- scrim ---------- */
  function scrim() {
    var el = $('.v-scrim');
    if (!el) {
      el = document.createElement('div');
      el.className = 'v-scrim';
      document.body.appendChild(el);
      el.addEventListener('click', closeAll);
    }
    return el;
  }
  function closeAll() {
    $$('.v-drawer.is-open,.v-mobnav.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    scrim().classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart drawer ---------- */
  function openDrawer() {
    var d = $('#VenroCart');
    if (!d) return;
    d.classList.add('is-open');
    scrim().classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function cartLineHTML(item) {
    var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return o.name + ': ' + o.value; }).join(' · ');
    return '' +
      '<div class="v-line" data-key="' + item.key + '">' +
        (img ? '<a href="' + item.url + '"><img src="' + img + '" alt="" loading="lazy"></a>' : '') +
        '<div style="flex:1;min-width:0">' +
          '<a class="v-line__t" href="' + item.url + '">' + item.product_title + '</a>' +
          (opts ? '<div class="v-line__v">' + opts + '</div>' : '') +
          '<div class="v-line__p">' + fmtMoney(item.final_line_price) + '</div>' +
          '<div class="v-line__act">' +
            '<div class="v-qty v-qty--sm">' +
              '<button type="button" data-cart-qty="-1" aria-label="minus">&minus;</button>' +
              '<input type="number" min="0" value="' + item.quantity + '" data-cart-input>' +
              '<button type="button" data-cart-qty="1" aria-label="plus">+</button>' +
            '</div>' +
            '<button type="button" class="v-line__rm" data-cart-remove>' + t('remove') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function t(key) { return (CFG.strings && CFG.strings[key]) || key; }

  function renderCart() {
    return fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = $('#VenroCartBody');
        var foot = $('#VenroCartFoot');
        if (body) {
          body.innerHTML = cart.item_count
            ? cart.items.map(cartLineHTML).join('')
            : '<div class="v-empty" style="border:0;background:none">' + t('empty') + '</div>';
        }
        if (foot) foot.style.display = cart.item_count ? '' : 'none';
        var tot = $('#VenroCartTotal');
        if (tot) tot.textContent = fmtMoney(cart.total_price);
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      });
  }

  function changeLine(key, qty) {
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(id, qty, btn) {
    if (btn) { btn.disabled = true; }
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.d.description || res.d.message || t('error')); return; }
        openDrawer();
        toast(t('added'));
      })
      .catch(function () { toast(t('error')); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-cart-open]'))) { e.preventDefault(); openDrawer(); return; }
    if ((el = e.target.closest('[data-close]'))) { e.preventDefault(); closeAll(); return; }

    if ((el = e.target.closest('[data-nav-open]'))) {
      e.preventDefault();
      var mn = $('#VenroMobNav');
      if (mn) { mn.classList.add('is-open'); scrim().classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      return;
    }

    if ((el = e.target.closest('[data-add]'))) {
      e.preventDefault();
      addToCart(el.getAttribute('data-add'), el.getAttribute('data-qty') || 1, el);
      return;
    }

    if ((el = e.target.closest('[data-cart-qty]'))) {
      var line = el.closest('.v-line');
      var input = $('[data-cart-input]', line);
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(el.getAttribute('data-cart-qty'), 10));
      changeLine(line.getAttribute('data-key'), next);
      return;
    }
    if ((el = e.target.closest('[data-cart-remove]'))) {
      var l2 = el.closest('.v-line');
      changeLine(l2.getAttribute('data-key'), 0);
      return;
    }

    if ((el = e.target.closest('[data-qty-step]'))) {
      var box = el.closest('.v-qty');
      var inp = $('input', box);
      inp.value = Math.max(1, parseInt(inp.value || 1, 10) + parseInt(el.getAttribute('data-qty-step'), 10));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    if ((el = e.target.closest('[data-buy-now-btn]'))) {
      e.preventDefault();
      var f = el.closest('[data-product-form]');
      var bid = $('[name="id"]', f).value;
      var bq = $('[name="quantity"]', f) ? $('[name="quantity"]', f).value : 1;
      el.disabled = true;
      fetch(routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(bid), quantity: Number(bq) || 1 }] })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { el.disabled = false; toast(t('error')); });
      return;
    }

    if ((el = e.target.closest('[data-share]'))) {
      e.preventDefault();
      var shareData = { title: document.title, url: window.location.href };
      if (navigator.share) { navigator.share(shareData).catch(function () {}); }
      else if (navigator.clipboard) {
        navigator.clipboard.writeText(window.location.href).then(function () { toast(t('copied')); });
      }
      return;
    }

    if ((el = e.target.closest('[data-wish]'))) {
      e.preventDefault();
      try {
        var key = 'venro:wishlist';
        var list = JSON.parse(localStorage.getItem(key) || '[]');
        var pid = el.getAttribute('data-wish');
        var idx = list.indexOf(pid);
        if (idx === -1) { list.push(pid); toast(t('saved')); }
        else { list.splice(idx, 1); toast(t('unsaved')); }
        localStorage.setItem(key, JSON.stringify(list));
      } catch (err) { /* storage unavailable */ }
      return;
    }

    if ((el = e.target.closest('[data-top]'))) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if ((el = e.target.closest('[data-gal-thumb]'))) {
      e.preventDefault();
      var wrapEl = el.closest('.v-gal');
      $$('[data-gal-thumb]', wrapEl).forEach(function (b) { b.classList.remove('is-active'); });
      el.classList.add('is-active');
      var main = $('[data-gal-main]', wrapEl);
      if (main) { main.src = el.getAttribute('data-src'); main.srcset = ''; }
      return;
    }

    if ((el = e.target.closest('[data-hero-dot]'))) {
      heroGo(el.closest('.v-hero'), parseInt(el.getAttribute('data-hero-dot'), 10));
      return;
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-input]')) {
      var line = e.target.closest('.v-line');
      changeLine(line.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
    if (e.target.matches('[data-scope-jump]')) {
      if (e.target.value) window.location.href = e.target.value;
      return;
    }
    if (e.target.matches('[data-sort]')) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
    if (e.target.matches('[data-facet]')) {
      var form = e.target.closest('form');
      if (form) form.submit();
    }
    if (e.target.matches('[data-variant-opt]')) selectVariant(e.target.closest('[data-product-form]'));
  });

  /* ---------- variants ---------- */
  function selectVariant(form) {
    if (!form) return;
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var chosen = $$('[data-variant-opt]:checked', form).map(function (i) { return i.value; });
    var match = variants.find(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    });
    var idInput = $('[name="id"]', form);
    var btn = $('[data-submit]', form);
    var priceNow = $('[data-price-now]', form);
    var priceWas = $('[data-price-was]', form);
    if (!match) { if (btn) { btn.disabled = true; btn.textContent = t('unavailable'); } return; }
    if (idInput) idInput.value = match.id;
    if (btn) { btn.disabled = !match.available; }
    if (priceNow) priceNow.textContent = fmtMoney(match.price);
    if (priceWas) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        priceWas.textContent = fmtMoney(match.compare_at_price);
        priceWas.style.display = '';
      } else { priceWas.style.display = 'none'; }
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    window.history.replaceState({}, '', url.toString());
  }

  /* ---------- product form submit (ajax) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = $('[name="id"]', form).value;
    var qty = $('[name="quantity"]', form) ? $('[name="quantity"]', form).value : 1;
    addToCart(id, qty, $('[data-submit]', form));
  });

  /* ---------- hero slideshow ---------- */
  function heroGo(hero, i) {
    if (!hero) return;
    var slides = $$('.v-hero__slide', hero);
    var dots = $$('[data-hero-dot]', hero);
    if (!slides.length) return;
    i = ((i % slides.length) + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    hero.dataset.index = i;
  }
  function heroInit() {
    $$('.v-hero').forEach(function (hero) {
      var slides = $$('.v-hero__slide', hero);
      if (slides.length < 2) return;
      var ms = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      setInterval(function () {
        if (document.hidden) return;
        heroGo(hero, (parseInt(hero.dataset.index, 10) || 0) + 1);
      }, ms);
    });
  }

  /* ---------- predictive search ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-search-input]')) return;
    var input = e.target;
    var box = $('[data-search-results]', input.closest('.v-search'));
    if (!box) return;
    clearTimeout(searchTimer);
    var q = input.value.trim();
    if (q.length < 2) { box.innerHTML = ''; return; }
    searchTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          box.innerHTML = items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            return '<a class="v-sr" href="' + p.url + '">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
              '<span><span class="v-sr__t">' + p.title + '</span>' +
              '<span class="v-sr__p">' + (p.price ? p.price : '') + '</span></span></a>';
          }).join('');
        })
        .catch(function () { box.innerHTML = ''; });
    }, 220);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.v-search')) {
      $$('[data-search-results]').forEach(function (b) { b.innerHTML = ''; });
    }
  });

  /* ---------- init ---------- */
  function init() {
    heroInit();
    $$('[data-product-form]').forEach(selectVariant);
    renderCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();